<template lang="html">

  <section class="btn-commencer">
    <a href="https://billeterie.skanticket.com/inscription" class="btn btn-lg btn-chevron btn-yellow btn-primary">Commencer maintenant</a>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'btn-commencer',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>
